import { GOOGLE_ADS_CAMPAIGN_STATUS } from '../../../../../../../services/exports/Constants';

export default {
  buttons: {
    back: 'Voltar',
  },
  metrics: {
    impressions: {
      label: 'Impressões',
      description:
        'O número de vezes que o seu anúncio foi mostrado nos resultados de pesquisa Google ou em sites parceiros.',
    },
    clicks: {
      label: 'Cliques',
      description: 'O número de vezes que as pessoas clicaram no seu anúncio.',
    },
    budget_spent: {
      label: 'Orçamento Gasto',
      description: 'O valor total gasto nesta campanha.',
    },
    absolute_top_impression_percentage: {
      label: '% de Impressões na Posição Absoluta do Topo',
      description: 'A percentagem de vezes que o seu anúncio apareceu no topo dos resultados de pesquisa do Google.',
    },
    phone_calls: {
      label: 'Chamadas',
      description: 'O número total de chamadas telefónicas recebidas através do seu anúncio.',
    },
    phone_impressions: {
      label: 'Impressões Telefónicas',
      description: 'O número de vezes que o seu número de telefone foi apresentado no anúncio.',
    },
    phone_through_rate: {
      label: 'Taxa de Chamadas',
      description:
        'A percentagem de impressões telefónicas que resultaram em chamadas reais (Chamadas ÷ Impressões Telefónicas).',
    },
    directions: {
      label: 'Direções',
      description: 'O número de vezes que os utilizadores clicaram para obter direções para o seu estabelecimento.',
    },
    daily_budget: {
      label: 'Orçamento Diário',
      description: 'O valor máximo definido para gastar por dia nesta campanha.',
    },
    status: {
      label: 'Estado',
      description: 'O estado de execução atual da sua campanha.',
    },
    ctr: {
      label: 'Taxa de Cliques',
      description: 'A percentagem de visualizações do anúncio que resultaram em cliques (Cliques ÷ Impressões).',
    },
    average_cpc: {
      label: 'Custo Médio por Clique',
      description: 'O valor médio pago cada vez que alguém clica no seu anúncio (Custo Total ÷ Cliques Totais).',
    },
    conversions_from_interactions_rate: {
      label: 'Taxa de Conversão',
      description: 'A percentagem de interações com o anúncio que resultaram numa conversão.',
    },
    start_date: {
      label: 'Data de Início',
      description: 'A data em que a campanha começou.',
    },
    sales_from_google_ads: {
      label: 'Vendas via Google Ads',
      description: 'O valor total gerado através do Google Ads.',
    },
  },
  status: {
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNSPECIFIED]: 'Não Especificado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.ENABLED]: 'Ativo',
    [GOOGLE_ADS_CAMPAIGN_STATUS.PAUSED]: 'Pausado',
    [GOOGLE_ADS_CAMPAIGN_STATUS.UNKNOWN]: 'Desconhecido',
    [GOOGLE_ADS_CAMPAIGN_STATUS.REMOVED]: 'Removido',
  },
  error_messages: {
    loading_failed: 'Falha ao carregar os detalhes da campanha. Por favor, tente novamente.',
  },
};
